/* MrHamsterDesigns — Size + Frame picker behaviour.
 *
 * This file only *decorates* the picker: live per-tile pricing, selected
 * state and the "all sizes" modal. Choosing a variant, updating the main
 * price and the add-to-cart button is still done entirely by the theme's
 * own <variant-selects> / product-info logic, which reads the same radio
 * inputs this picker renders. Nothing here touches the cart.
 */
(function () {
  'use strict';

  // The theme can re-render the product section and re-inject this script.
  if (window.__mrhPickerLoaded) return;
  window.__mrhPickerLoaded = true;

  var decoder = null;
  var lastFocus = null;

  function decodeEntities(str) {
    if (!str || str.indexOf('&') === -1) return str;
    if (!decoder) decoder = document.createElement('textarea');
    decoder.innerHTML = str;
    return decoder.value;
  }

  function readData(picker) {
    var el = picker.querySelector('script.mrh-variant-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function checkedValue(picker, optKey) {
    var input = picker.querySelector('input.mrh-radio[data-mrh-opt="' + optKey + '"]:checked');
    return input ? input.value : null;
  }

  function findVariant(variants, frame, size) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].f === frame && variants[i].s === size) return variants[i];
    }
    return null;
  }

  function paint(picker) {
    var variants = readData(picker);
    if (!variants) return;

    var frame = checkedValue(picker, 'frame');
    var size = checkedValue(picker, 'size');

    // Price on every size tile, for the frame that's currently chosen.
    picker.querySelectorAll('[data-mrh-price-size]').forEach(function (node) {
      var v = frame ? findVariant(variants, frame, node.getAttribute('data-mrh-price-size')) : null;
      node.textContent = v ? decodeEntities(v.price) : '';
      var tile = node.closest('.mrh-tile');
      if (tile) tile.classList.toggle('is-unavailable', !!v && !v.a);
    });

    // Price on every frame tile, for the size that's currently chosen.
    picker.querySelectorAll('[data-mrh-price-frame]').forEach(function (node) {
      var v = size ? findVariant(variants, node.getAttribute('data-mrh-price-frame'), size) : null;
      node.textContent = v ? decodeEntities(v.price) : '';
      var tile = node.closest('.mrh-tile');
      if (tile) tile.classList.toggle('is-unavailable', !!v && !v.a);
    });

    // Selected state on every tile (main row and modal share the inputs).
    picker.querySelectorAll('label.mrh-tile[for]').forEach(function (label) {
      var input = document.getElementById(label.getAttribute('for'));
      label.classList.toggle('is-selected', !!(input && input.checked));
    });

    // Pretty summary next to each option heading.
    var sizeOut = picker.querySelector('[data-mrh-out="size"]');
    if (sizeOut && size) sizeOut.textContent = size;

    var frameOut = picker.querySelector('[data-mrh-out="frame"]');
    if (frameOut && frame) frameOut.textContent = frame.replace(/\s*Frame$/i, '');
  }

  function paintAll() {
    document.querySelectorAll('.mrh-picker').forEach(paint);
  }

  /* --- containing-block fix -------------------------------------------
   * The product info column carries the theme's scroll-reveal classes,
   * which set both a `transform` and an `animation-name`. Either one makes
   * the element a containing block for `position: fixed` descendants, so
   * the modal was being laid out inside the ~385px product column instead
   * of over the viewport, and the largest size tiles were cut off.
   *
   * We cannot just move the modal to <body>: it contains 15 of the
   * product's real variant radio inputs, and pulling those out of
   * <variant-selects> would break size selection. Instead we neutralise
   * the offending ancestor (see .mrh-modal-host in mrh-picker.css) for as
   * long as the modal is open, then restore it.
   */
  function containingBlockAncestor(node) {
    var el = node.parentElement;
    while (el && el !== document.body && el !== document.documentElement) {
      if (!el.classList.contains('mrh-modal-host')) {
        var c = getComputedStyle(el);
        if (
          c.transform !== 'none' ||
          c.animationName !== 'none' ||
          c.filter !== 'none' ||
          c.perspective !== 'none' ||
          (c.willChange && /transform|filter|perspective/.test(c.willChange))
        ) {
          return el;
        }
      }
      el = el.parentElement;
    }
    return null;
  }

  function releaseHosts() {
    document.querySelectorAll('.mrh-modal-host').forEach(function (el) {
      el.classList.remove('mrh-modal-host');
    });
  }

  function openModal(modal) {
    if (!modal) return;

    lastFocus = document.activeElement;

    // There can be more than one such ancestor — keep walking until clear.
    var guard = 0;
    var host = containingBlockAncestor(modal);
    while (host && guard < 10) {
      host.classList.add('mrh-modal-host');
      guard++;
      host = containingBlockAncestor(modal);
    }

    modal.removeAttribute('hidden');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    document.body.classList.add('mrh-locked');

    var focusable = modal.querySelector('.mrh-modal__close');
    if (focusable) focusable.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    modal.removeAttribute('aria-modal');
    document.body.classList.remove('mrh-locked');
    releaseHosts();

    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  function closeAllModals() {
    document.querySelectorAll('.mrh-modal:not([hidden])').forEach(closeModal);
    releaseHosts();
    document.body.classList.remove('mrh-locked');
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var opener = event.target.closest('[data-mrh-open]');
    if (opener) {
      event.preventDefault();
      var scope = opener.closest('.mrh-opt') || document;
      openModal(scope.querySelector('.mrh-modal'));
      return;
    }

    if (event.target.closest('[data-mrh-close]')) {
      event.preventDefault();
      closeAllModals();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllModals();
      return;
    }

    // Keep tabbing inside the dialog while it is open.
    if (event.key !== 'Tab') return;
    var modal = document.querySelector('.mrh-modal:not([hidden])');
    if (!modal) return;

    var items = modal.querySelectorAll(
      'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // A size picked inside the modal closes it; the theme then swaps the variant.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('mrh-radio')) return;
    if (input.closest('.mrh-modal')) closeAllModals();
    paintAll();
  });

  // The theme re-renders <variant-selects> after every option change, which
  // wipes the classes and prices we just set — repaint whenever that happens.
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      paintAll();

      // A re-render can replace an open modal with a fresh hidden copy. If
      // nothing is open any more, make sure we did not leave the page
      // scroll-locked or an ancestor still neutralised.
      if (!document.querySelector('.mrh-modal:not([hidden])')) {
        releaseHosts();
        document.body.classList.remove('mrh-locked');
      }
    });
  });

  function boot() {
    paintAll();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
